<template>
	<span class="">
        <span v-if="this.colour === 'green'" class="bg-green-100 border border-green-400 text-green-800 text-xs font-semibold px-3 py-1 rounded-full text-nowrap">
            {{ text }}
        </span>
        <span v-if="this.colour === 'yellow'" class="bg-yellow-100 border border-yellow-400 text-yellow-800 text-xs font-semibold px-3 py-1 rounded-full text-nowrap">
            {{ text }}
        </span>
        <span v-if="this.colour === 'red'" class="bg-red-100 border border-red-400 text-red-800 text-xs font-semibold px-3 py-1 rounded-full text-nowrap">
            {{ text }}
        </span>
        <span v-if="this.colour === 'blue'" class="bg-blue-100 border border-blue-400 text-blue-800 text-xs font-semibold px-3 py-1 rounded-full text-nowrap">
            {{ text }}
        </span>
		<span v-if="this.colour === 'gray'" class="bg-gray-100 border border-gray-400 text-gray-800 text-xs font-semibold px-3 py-1 rounded-full text-nowrap">
            {{ text }}
        </span>
	</span>
</template>

<script>

export default {
	name:"status-pill",
	components:{

	},
	props:{
		text:{
			type:String
		},
		colour:{
			type:String
		},
	},
	data(){
		return{

		}
	},
	mounted(){

	}

}
</script>

<style>

</style>